define('apps/course-intro/templates/regions/badges/content',['handlebars'], function(Handlebars) {

return Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  


  return "<header>\n    <h1 class=\"main-title\">Complete modules to unlock badges.</h1>\n</header>\n<section class=\"grid-region\"></section>\n";
  })

});
